// extracted by mini-css-extract-plugin
module.exports = {"content":"Reference_content__oMJPi","submitBtn":"Reference_submitBtn__2t48o"};